<template>
  <nav
    class="navigation"
    :class="{
      'mobile': isMobile,
      'dark-theme': isLoginPage ||
        $route.path.includes('change_password') ||
        $route.path.includes('visit_cancellation') ||
        $route.path.includes('user_activation'),
      'hide': hideNav,
    }"
  >
    <div
      class="trademark-wrapper"
      @click="$router.push({ path: '/' })"
    >
      <img
        class="trademark"
        src="../assets/skoda-logo.svg"
        alt="#"
      >
    </div>
    <template v-if="loginStatus.loggedIn && !$route.path.includes('visit_cancellation')">
      <div class="menu-controls">
        <div
          @click="toggleNav"
          class="burger-menu"
          :class="{ 'open': showNav }"
        >
          <span />
          <span />
          <span />
        </div>
        <ul
          class="navigation-list"
          :class="{ 'open': showNav }"
        >
          <li
            class="navigation-element"
            v-for="(elem, index) in navigation"
            :class="{ 'active': checkActiveRoute(elem.to) }"
            :key="index"
          >
            <router-link
              class="navigation-element-link"
              :to="elem.to"
              @click.native="toggleNav"
            >
              {{ elem.name }}
            </router-link>
          </li>
          <li class="vgp-link">
            <a href="https://www.skoda-auto.pl/">
              Przejdź do <span>skoda-auto.pl</span>
            </a>
          </li>
          <div class="spacer" />
          <div class="user-controls">
            <div class="user-info">
              Zalogowany jako:
              <span class="bold">
                {{ `${userInfo.firstName} ${userInfo.lastName}` }}
              </span>
            </div>
            <div class="user-buttons">
              <button
                class="icon-button"
                @click="goToUserProfile"
                v-tooltip.bottom="{ content: 'Profil', classes: 'nav-buttons-tooltip' }"
              >
                <svg class="user-icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="62" height="62" viewBox="0 0 62 62"><image width="62" height="62" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAYAAABzwahEAAAJfklEQVRoQ81bfXBU1RX/nfeSUBJEER1gWlo6bTGQ5C1Ky9S/YEoBkw1fjsm+DUqLH0WpQyutnVHHNs6oTKn1g1oKRaHVkmxC5Sv7FkRqsdPWVopm3yZ8WUcLdoShKgJJJJt3T+fubmCzJOzuuy/B+++753fO7917z733nHMJg9gqm6+/Vnec6QD5QDyJgYkArgVwBYCSlOoOAGcAnCTgCJgOAhx1dP21nbVvnRws88hr4Mrm6ydrLBYzcyUBhgo+AzYR7RSkvbCz9q0DKliZsp4Qr2kuK+p09NtAWAbghgwl7QS8zkSHCHxEkHaM4s7puENnZb9CnUdwoT5SYzGeQROJuZSBGwGUZeC8CcaaYt15cXNte7fqT1AiPnXd1MJxV3YvFaCfEDA+ZUwPAzs1cJOjFex2O10Ty0T0zBagAAGVAAokPgPHNPCqDz4pWrd/6f642x/gmnh145QZTGINgEkp5ceJ+CmHCja6JTsQicRP4J4lzHQfgLGpfgeJtWXhYOteN+TzJj77BaOksJBXg+j2hELGh0RcP1wb8fzm2te73BiRq0xN843Du8TZO5ipHoTRSf28IR6n5bsX29JJ5tzyIj63wVcmNNEM0OTkrKP1PVrPAy/Xtn+Us0YPOs5pLru6QBSsBPguAATwAU1otS110fZc4XMmXt1kzGVGCEAxgBPEWBQO2n/KVdFg9KtuNGYyYROAMQA6iWCGA3ZLLrpyIu5vMr4DxgYAGjNeg+6Ykdr247koGOw+Vc1lY+HoISJMByBAuN0K2L/Ppjcr8RTp3yWBaHOx1nOrF9tJNsPy+Z7YTkXBHwCuSZqJ72Yjf0ni/kZjHghbUyO9tkS/7t7NtZudfIwaqr41zTV6h3P4WSLcnRh5xkIraO8YSP+AxJOOjN9Irmk50hODn1XSveQk+U5xpDE18p2aoGkDObx+iSe2rCJJmibLNV2iO7O9mN5zXpw6rqAwPh2ECjBfAWjEzGc04rfh6H8NL2p9W3WGyGnf4ei7k2ueD8S7aVp/W12/xP2NFc+n9ukTrDlTVB2ZP2SUA3gEwAK5bC5BLkbgn4cDsQaQ3C7dNenwSOitCW/PvMEKxu7IRLqIeGWD8S1Ng9ymmBizlLYsBvlDxgMg/AxAUR40Iue0wro9tfs/yUOmT9fUVveKdHVCYObOOvvV9A59iCe9ox4FUArwOsuMSUfhuvlDhjzS3uMGgIB/OCM7Z+ys+vc5N/JSxh+qWAvQUgCHijXHl75c+xD3h4wfAnhK3o3h8HXWotjHbpVWhyruZdCv3MqntqXHrYD9kFsM/6aKUdDpcCoGcJ9l2k/3Yp0nnhht1t8B4wsAllmm/Ru3ClNO7B0Aw91ipOQ+1YWYsKOu7YRbHH/IkDNuDQjvF5Pzld5RP0+8usl3NzNLssc7uk5/ee+S9z51razJ9ySY5U3Kg0bLLTPqeubM2DjhcyXDR74rb3VEdE84EF0rjTpP3B/ytQLsI9CPwmb0SdcWS4fWXPFfMI1zjdFXcLtl2nI3cN2qQ74VDP4lQFHLjE45T3xeQ7nhaJp0avGiou5xW28+9KFbLf5Q+SRA8yxMRMDhsGmXurVHyi3cUjq6u7vog0TARwjfjro2OzHi/ibjF2D8mEHbImZ0oYoSr4mnj5KKXVUh31YCLwDhCStg358kHjLaZIyLiQKRQLRZRcFNjVMm6CTkmvKkMXhfxIxNUwWravLVEnMTgHbLtMtpXkP5GEfT5BWTezTnGtWgQjJIoLteKhcRJHrFCkRnqxJP2fU/6dd0IcbKk5UJoNGrKZWcQRWfADRS1diEPGO9FbS/5wVWrwMHEJTEHwUgDwlrLNP+vscK1OEYD1lB+3F1oMSS/rU8owB4TBJ/CcDNzPhBJGivVlXgbzIeA+NBVZw0eaFB+2aL2bpPFbOq0VhOhGcAbJHEYwDKCTQnbEZ3q4L7Q4YFoEoVJ12emZdEgrFUFMg9cnXIN5vBLwNok8SlYxsjNL3MizSNP2RsAzDfvXkXSxL41rAZk0FFpZZIbwlHRmJPSOIylVNSwOKL24Ntx5SQAVSHjPUM3KmK02fEBSojdfYuVcz5jeXje0g7CqBDEk9c+AuHaaO2LWw9pQruD1U8AtBPVXHS5b2ajQu2Trkqfk4kbpyeE69u9C1k4i0eEu8QIztHq9zLe23JJO7pVK+MfHWYfrp4LwPytHWpMFMu/6aTiVdGAjG55Sq3zKnuqXPrtc4fMvYAmKlmLS+1zNhv1TAuSGc6N0+3swvEfesAVjpx9RcrU/kJmduZpweYXsM8WOuere1emzIPMJ4fWaWi9MiHm1Ei4LmwactsqGct88jq+SUlbZ3Lc7E8H+fbujTNKW2pbZd7rmetzyXF62tpupX19dD2TTIsMG7Kx3oG7oqY9nP5yGTre9G1VAp4GYjINCBVMvLnbIalfT9qmfaX8uifU9eLAhEJ4h6Gnjwg/h/LtCfkxCaPTv2GnrwMNn4WiQ8YbExOd4/CyxnMXUx1z0d8wPCytNXLhEI698tNPGtCwcsUkiQuPfobk3y3UCIaw748lqO8Le4Ai1VWsO3vecj12zVrCinl3ZWThnNbphY7HfE6Au5HsmhXpb1J4GfPdp1pdJPSyilpKK1TSRMnk/8yJcu3AbhShW0/sh+BaL0jaO2uYOt7uWLnnCaWgPkUBsxtmHoNa92mABYT6Bu5GqTQj5nxF03jTXESL10qB5BXYUCvQQOVgiRqY4bhFmaaTmBJVFY4qt653f4H6QsOAPQ3IrH96wdju+rrISSYq1IQKdhf8U9HD00nTZORlRFuLR1kuXehcU0xRMx18Y80sE+5F+GPYEjP/LVBNl4V/p8AHXVd7nVhyl8o8FO1aIjl3Rf4nSefrGNVDuYPKXHVks5eY6tChswnrxpS410qI8KD4YC9Mpt41iLeXoDqkLGYgY2X0Ytn4yIIfGfYjEkbs7aciSccXsi4QQAyejoqK/LQdjjFLGZFgm3/ylVtXsQvbHWQ+bFv56pkMPsR4dXuc5g3qE8z0gmkXizIgvjLNfqnNOIlLYGYHIS8W94jnq5BPr8ae1W8Hgx5uZFPNoaidYFo9fFTBQ9fludX6QwTpdKiYAWBV6TKJwfjB5wE4+li3XnCixJypRHvj11Vc0UFCe1hgGX66GrFP/AxQHt04Twqa9MUsfqIe048HV0+lCPhzCfmWUxUSozPgxJnfflqUE/1lU89emTOmoH3ifkQadjjUME2rx/updv2fxqemSXRFHRGAAAAAElFTkSuQmCC"/></svg>
              </button>
              <button
                class="icon-button"
                @click="onLogout()"
                v-tooltip.bottom="{ content: 'Wyloguj', classes: 'nav-buttons-tooltip' }"
              >
                <svg class="logout-icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="62" height="62" viewBox="0 0 62 62"><image width="62" height="62" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAYAAABzwahEAAAHNUlEQVRoQ+Wbe2xURRSHf2cuqO2CMT6CsT5AUUS6t0QxokYTxBe9FTCm290qGF8ERVEjmhgTRaOJEY0CokaFICj7qA8eexcxKsTEV0TTvduqIAJRMRofMUpbld45Zm7vNsvSsrt3t3Trzr/3zpnzzZw5M3PmDGEAy/Q1taNsIaYAqAUwHsAZAI4DMAKAz226A8BeAL8A2A7gKwBtmpSb1ze3/TxQ6lGpBU9fU6vbmpgFxjQAEzLk/83AdgHsYea/QPSX8415JBGNlEAN9XTMERl12kHYqNly9frmNquUupYEvDE24bAuHnYjM+YCXOcquBOgdwHebLP4ZPK21u8WLoQ8mPILF0J8Mm7iyRrJyQBNAfhSAKf21KEkEV6oou4VLYH2f4vthKLAFXCn1G4DcC+AEwD8SoQ1TLzKDKQ+L1Y5Vd+I+c8hptnMaAZwLIAfASyqFvZzxXSAZ/CGsD4VhGUMjGPgewItqhbVL7cEPu4qBXC2jMbY+VWdsvNmBt9LwEkEbANjXjxkveelvYLBG2MTRnRIbRkBsx2nxHi4WrOXFNP7hSjuWJmtzQfhIeUkGVjlE/a8lkC7cpB5l4LA62N+v5DUokYZwDrZjds3Xmf9kHdrJfxx2qv6iWIYngUwQ42+FNyYCKRS+TaRN/hVUf9MybQGgEbge+LBlGp00EtDxH87g54CYAvi5g1NqbX5KJUXuBHWbwLhRQC/Mcv6RKhtaz7CD9U/9eHaSUQiAeAYMOaYIWt5rrZzgrvQLwPYqYnuK9YHvtyRS+hgfJ8eO2usLYdtcpY/xs254A8K7pr3GwB2k6CL44HknsGAyrfNhlhdDUv+AMBoQXzNwcy+X3DlyEjSp8pza6L7gnId6exOcUf+I8fjCz6vP4fXJ7hasrqktpWBMczywnKb07kswJ3zHxKwq0rYk/pa6voEr4/or6h1msB3ePHeauv52en+0TxcOzKXkn19Jym7hx8uflh7desfXuqrOq63X6rW+UTQuj5bzgHgakfGhHfVOm0GrZmFNuz6BbXU1RRaN+t/ta9f2y3sWzYF2n/3IsuI6Gppm0GMS7N3ePuBO4cNqVkM1MhujC90c2KE9YtA2AJAANgHoNOLwgATQK618BazKXUJCFyoLHeT8xUBe6qErWfuLvcDNyL6XQCeZuC+RNBaVGhDRlRfB8Z0EF7v6Pxz1pYbdv9dqIz0//Vh/TwibAZQxYzJiZClHG3BpT6iq739EwDuNoPWM2kBveDuSWsXA7ZP2GO97L2NiL7NCTYQX2Y2pdR0KaoY0bp3wHwZM81OhJKrvQhTXB1S20GAVi3sMWmuXvCGaN1cZn4eoPlmMLnUSyNGRN8N4BRiMSUealUmX1RJz1FmviERSq30KsyI1N0B8BIiujXelHxByekFNyJ1rQDXVAvfyV6PluUK3nOk7fgOoD1mMDmxF9wJFwmhIhxL4k3Wnd57tjxH3FneovpiZszXpKxTYSxnxI2ovgiMBRA8qZjISbmOuMMY858DSVtBeNJsspTDA4yI3qa8pxm0TvM62q6cspzjaSYjon8LoMsMWrXkhoB/AuMlM2TNKSvwaN3jYF5Agi+KB1IfF6ObMzBh/UUQbtGkPJ6MiB4EEAYQMoNWpBjhpTZ1pcvlq3TfO7MtFXsvumSyKvBHATxgsxjzdqhVmarnMhDgnpXpo+KV4YmjNZK7ADymwNV5u/7cry1frrh3LiXKHdw5PJ2pK+tJKPAUAzIRtNIXAbn4+v0+kOAz35p4lN3FNRuak+2eFVQjHNGTBAgF/hMBX8SDVn0xAgfCq2fqY4T1lSDMIuL7400ptff2VBoieoKBsxX4XjCbZijV5ElSRqVCR7wx1qjtG/7NyHza3fePfE0NmPMv45VqzZ7j6TwR9kdBZChwBvMKM5S6KR8FDvZPIeBXxCYcPUxqXwIY5bFdT/ECI+xfDqIbhyx4f5GVXJ2YCT7kTJ2BxT4x7p6WQIudCzT7u5Fh6kPCublxwOuYeX4ilFpWKHD6/0znNiSWsx6fQKPMYJvKmPBcMpezit3AVOyWtWwPKVfF9DG2xFSfsFd5WbMPcGwZB7LyPpb2eOAAMQXjoWTU88R2K+53LHW3mpUXiHDAKzX0VLHBxh5zr8DwsgKv2AsF9wpppwpK/E+vkES1sE894ArJ9e6luTQE3uzo+vPaYi4Np0X0yQJ4f8AvDRV4xV4TO3O9FIkBoKVgnFjkhuPQJQakFS1FKojKQhYajvICPyipIK7JV2byj4KvyHSvtHlWZIJfGr4iUzqz4CsriTfL7Csrbbt3mavERP00fPbTDAYe8Ql7cSlCQ/ms+W761p0EPHjInmZkKlZxj3Ey4TOeXy1wc1ed51dSytWlynhWmchCiFkZz69UzvyTg/b8KrsD+nxwx3gPhPc9PbhjqPzVqWX54K6vOZnXE0vQXrDseWJJYiSBRwzJJ5b9OaVyflT7H9ROUTSA5iTkAAAAAElFTkSuQmCC"/></svg>
              </button>
            </div>
          </div>
        </ul>
      </div>
      <div
        v-show="isMobile && showNav"
        @click.self="toggleNav"
        class="nav-mobile-overlay"
      />
    </template>
    <div
      class="vgp-link"
      v-else
    >
      <a href="https://www.skoda-auto.pl/">
        Przejdź do <span>skoda-auto.pl</span>
      </a>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    hideNav: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      thirdColor: 'brand/getThirdColor',
      primaryColor: 'brand/getPrimaryColor',
      userInfo: 'user/getUserInfo',
      loginStatus: 'auth/getAuthStatus',
      fonts: 'brand/getFonts',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    isLoginPage() {
      return this.$route.name.includes('LoginPage');
    },
  },
  data() {
    return {
      showNav: false,
      navigation: [
        {
          name: 'Moje samochody',
          to: '/dashboard/mycars',
        },
        {
          name: 'Wizyty serwisowe',
          to: '/dashboard/visits/next/all',
        },
        {
          name: 'Znajdź Partnera Serwisowego',
          to: '/dashboard/map',
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
    checkActiveRoute(path) {
      return path === this.$route.path;
    },
    onLogout() {
      this.toggleNav();
      this.logout();
    },
    goToUserProfile() {
      this.$router.push({ path: '/dashboard/profile' });
      if (this.isMobile) {
        this.toggleNav();
      }
    },
    toggleNav() {
      this.showNav = !this.showNav;
    },
  },
  watch: {
    hideNav() {
      if (this.hideNav) {
        this.showNav = false;
      }
    },
  },
};
</script>
